import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Button } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import TextInput from "../../custom/components/Text-Input/TextInput.js";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createPageData, basicFormData } from "./JobCardFile.js";
import CheckboxInput from "../../custom/components/CheckBox-Input/CheckboxInput.js";
import { validate } from "../../custom/validations/Validate.js";
import { getRecords, saveRecords } from "../../services/api.service.js";
import { toast } from "react-toastify";
import { LoaderCreatePage } from "../Loader/Loader.js";
import { loaderOverlay } from "../../Style/loaderOverly.js";
import BasicPopupModel from "../../custom_components/Components/BasicPopupModel.js";
import Select from "react-select"
import CustomError from "../../custom/components/Errors/CustomError.js";

const JobCardCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  } = createPageData();


  const [popup, setPopup] = useState(false)
  const [action, setAction] = useState("")
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [scrapReasonsOptions, setScrapReasonsOptions] = useState([])
  const [selectedScrapReasons, setSelectedScrapReasons] = useState({})
  const [scrapReasonsError, setScrapReasonsError] = useState("")
  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(basicFormData());
  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  useEffect(() => {
    getScrapReasonsData()
  }, [])
  

  const getScrapReasonsData = async () => {
    setLoadingData(true)
    try {
      let payload = {
        modelName: "scrap_reason_masters",
        whereCondition: {
          is_active: true
        },
        schema: initialPayload?.schema
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map(item => ({
        value: item.id,
        label: item.reason
      }));
      setScrapReasonsOptions(newArray)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false)
  };


  const handleScrapReasonsSelect = (options) => {
    const selectedValue = options ? options.value : "";

    setSelectedScrapReasons(options);

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        scrap_reason_id: selectedValue,
      },
    }));

    setScrapReasonsError("")
  };

  const getEditData = async (id) => {
    setLoadingData(true)
    try {
      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
        include: initialPayload?.include
      }

      if (id) {
        payload.whereCondition = { id: id };
      }
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        let data = responseData.data[0];
        const currentDate = new Date()
        data = { ...data, technician_check_at: currentDate.toString() }

        setFormData({ inputData: data })
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };



  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormErrors((prevErrors) => {

      const fieldError = validate(validationType, { [name]: value });
      return {
        ...prevErrors,
        [name]: fieldError[name] || null,
      };
    });

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]:
          type === "checkbox"
            ? checked === true
              ? 1
              : 0
            : name === "alt_mobile_number" && value === ""
              ? null
              : value,
      },
    }));
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoadingSubmit(true);

      const userDetails = JSON.parse(localStorage.getItem("authUser"));
      const validationErrors = validate(validationType, formData.inputData);
      setFormErrors(validationErrors)

      if (JSON.stringify(validationErrors) !== "{}") return
      // Additional validation for `user_documents`

      if (action === "Reject" && !selectedScrapReasons?.value) {
        setScrapReasonsError("Scrap Reason is required")
        return
      }

      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
      };


      if (id) {
        // update
        formData.inputData.updated_by = id ? userDetails?.id || "" : "";
        payload = {
          ...payload, id: id, inputData: {
            technician_id: formData.inputData.technician_id,
            technician_check_remark: formData.inputData.technician_check_remark,
            technician_check_is_repairable: action === "Approve" ? true : false,
            technician_check_at: formData.inputData.technician_check_at
          }
        }
      }

      if (action === "Approve") {
        payload = {
          ...payload, id: id, inputData: {
            technician_id: formData.inputData.technician_id,
            technician_check_remark: formData.inputData.technician_check_remark,
            technician_check_is_repairable: true,
            technician_check_at: formData.inputData.technician_check_at
          }
        }
      } else {
        payload = {
          ...payload, id: id, inputData: {
            technician_check_remark: formData.inputData.technician_check_remark,
            technician_check_is_repairable: false,
            technician_check_at: formData.inputData.technician_check_at,
            scrap_reason_id: selectedScrapReasons?.value,
            scrap_remark: formData.inputData?.scrap_remark,
            intake_id: formData.inputData?.intake_id
          }
        }
      }
      console.log(payload)
      // return;
      const responseData = await saveRecords(payload, createEndpoint);


      // Handle response
      if (responseData && responseData.code === 1) {

        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`
        );
        setPopup(false)
        if (action === "Approve") {
          
          navigate(navigatePage?.back);
        } else {
          navigate("/scrap-list")
        }
      } else {
        toast.error(
          responseData.message || `Error while saving ${headerName}!`
        );
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingSubmit(false);
    }
  };

  // add document



  return (
    <div className="page-content">
      <Breadcrumbs title={"Job Card Approval"} breadcrumbItems={[]} />
      <div className="card mb-3">
        <div className="container-fluid p-4 ">
          <p className="text-muted pb-1">
            Fields marked with <span className="text-danger fw-bold">*</span>{" "}
            are required.
          </p>
          <form>
            <Row className="mt-2">
              <Col md="6" className="mt-3">
                <TextInput
                  label="Intake No"
                  name="intake_no"
                  value={formData?.inputData?.intake?.intake_no || "-"}
                  onChange={onInputChange}
                  placeholder="Intake No"
                  inputClassName="form-control"
                  labelClassName="form-label"
                  asterisk={true}
                  customError={formErrors?.intake_no}
                  disabled={true}
                />
              </Col>
              <Col md="6" className="mt-3">
                <TextInput
                  label="Job Card No"
                  name="job_card_no"
                  value={formData?.inputData?.job_card_no || "-"}
                  onChange={onInputChange}
                  placeholder="Job Card No"
                  inputClassName="form-control"
                  labelClassName="form-label"
                  asterisk={true}
                  customError={formErrors?.job_card_no}
                  disabled={true}
                />
              </Col>
              <Col md="6" className="mt-3">
                <TextInput
                  label="Technician Name"
                  name="technician"
                  value={
                    formData?.inputData?.technician
                      ? `${formData.inputData.technician.first_name || "-"} ${formData.inputData.technician.last_name || "-"
                      }`
                      : "-"
                  }
                  onChange={onInputChange}
                  placeholder="Technician Name"
                  inputClassName="form-control"
                  labelClassName="form-label"
                  asterisk={true}
                  customError={formErrors?.technician}
                  disabled={true}
                />
              </Col>

              <Col md="6" className="mt-3">
                <TextInput
                  label="Assigned By"
                  name="assigned_by"
                  value={
                    formData?.inputData?.assigned_by_user
                      ? `${formData.inputData.assigned_by_user.first_name || "-"} ${formData.inputData.assigned_by_user.last_name || "-"
                      }`
                      : "-"
                  }

                  onChange={onInputChange}
                  placeholder="Assigned By"
                  inputClassName="form-control"
                  labelClassName="form-label"
                  asterisk={true}
                  customError={formErrors?.assigned_by_user}
                  disabled={true}
                />
              </Col>
              {/* <Col lg="12" className="mt-4">
                <CheckboxInput
                  name="technician_check_is_repairable"
                  label="Technician Check Is Repairable"
                  value={formData?.inputData?.technician_check_is_repairable}
                  checked={formData?.inputData?.technician_check_is_repairable}
                  handleTextChange={onInputChange}
                  parentClassName="form-check"
                  checkBoxClassName="form-check-input"
                  labelClassName="form-check-label"
                />
              </Col> */}






            </Row>

            <Row className="mt-4">
              <Col lg="12">
                <CheckboxInput
                  name="is_active"
                  label="Is Active"
                  value={formData?.inputData?.is_active}
                  checked={formData?.inputData?.is_active}
                  handleTextChange={onInputChange}
                  parentClassName="form-check"
                  checkBoxClassName="form-check-input"
                  labelClassName="form-check-label"
                />
              </Col>
            </Row>
          </form>

          <div className="mt-3 d-flex gap-3 flex-wrap">
            <button type="button" className="btn btn-primary" onClick={() => {
              setPopup(true)
              setAction("Approve")
            }}>
              Approve
            </button>
            <button type="button" onClick={() => {
              setPopup(true)
              setAction("Reject")
            }} className="btn btn-secondary">
              Reject
            </button>
            <button type="button" onClick={() => { navigate(navigatePage?.back) }} className="btn btn-secondary">
              Cancel
            </button>
          </div>


          <BasicPopupModel
            isVisible={popup}
            onClose={() => setPopup(false)}
            title={action === "Approve" ? "Approve Job Card" : "Reject Job Card"}
          >
            <div>
              {action === "Approve" ? (<form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <span className="alert alert-success p-2"> The Job Card will be Approve ! </span>
                </div>
                <Row>
                  <Col md="6" className="mt-3">
                    <TextInput
                      label="Technician Check Remark"
                      name="technician_check_remark"
                      value={formData?.inputData?.technician_check_remark}
                      onChange={onInputChange}
                      placeholder="Technician Check Remark"
                      inputClassName="form-control"
                      labelClassName="form-label"
                      asterisk={true}
                      customError={formErrors?.technician_check_remark}
                    />
                  </Col>

                </Row>
                <div className="mt-4 d-flex gap-3 flex-wrap">
                  <button type="submit" className="btn btn-primary">
                    Submit
                  </button>
                  <button type="button" onClick={() => {
                    setPopup(false)
                  }} className="btn btn-secondary">
                    Cancel
                  </button>
                </div>
              </form>) : (<form onSubmit={handleSubmit}>

                <div className="mb-4">
                  <span className="alert alert-warning p-2"> ! Warning: The Job Card will be Rejected </span>
                </div>

                <Row>
                  <Col md="6" className="mt-3">
                    <TextInput
                      label="Technician Check Remark"
                      name="technician_check_remark"
                      value={formData?.inputData?.technician_check_remark}
                      onChange={onInputChange}
                      placeholder="Technician Check Remark"
                      inputClassName="form-control"
                      labelClassName="form-label"
                      asterisk={true}
                      customError={formErrors?.technician_check_remark}
                        
                    />
                  </Col>

                  <Col md="6" className="mt-3">
                    <label htmlFor="scrap_reasons">
                      Scrap Reasons <span className="text-danger">*</span>
                    </label>
                    <Select
                      options={scrapReasonsOptions}
                      value={selectedScrapReasons}
                      onChange={handleScrapReasonsSelect}
                      placeholder="Select Scrap Reasons"
                      classNamePrefix="react-select"
                      className={scrapReasonsError.length ? "input-error" : ""}
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            borderColor: scrapReasonsError.length
                              ? "#d15757"
                              : state.isFocused
                                ? "blue"
                                : "#ccc",
                          })
                        }}
                      
                    />
                    {scrapReasonsError && <CustomError error={scrapReasonsError} />}
                  </Col>

                </Row>

                <Row className="mt-3">
                  <Col md="6" className="mt-1">
                    <TextInput
                      label="Scrap Remark"
                      name="scrap_remark"
                      value={formData.inputData.scrap_remark}
                      onChange={onInputChange}
                      inputClassName="form-control"
                      labelClassName="form-label"
                    />
                  </Col>

                </Row>
                <div className="mt-4 d-flex gap-3 flex-wrap">
                  <button type="submit" className="btn btn-primary">
                    Submit
                  </button>
                  <button type="button" onClick={() => {
                    setPopup(false)
                  }} className="btn btn-secondary">
                    Cancel
                  </button>
                </div>
              </form>)}
              {loadingSubmit && (
                <div style={loaderOverlay}>
                  <LoaderCreatePage />
                </div>
              )}
            </div>
          </BasicPopupModel>

        </div>
        {loadingData && (
          <div style={loaderOverlay}>
            <LoaderCreatePage />
          </div>
        )}
      </div>
    </div>
  );
};

export default JobCardCreate;
